
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","fill":"none","viewBox":"0 0 18 19"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#71798A","d":"M8.543 12.284l.007-.007a.509.509 0 00.023-.022l3.57-4.02a.495.495 0 00-.009-.7.495.495 0 00-.7-.007l-3.27 3.69-1.315-1.082a.495.495 0 00-.7.008.495.495 0 00-.008.7l1.779 1.478c.191.19.42.166.615-.03l.008-.008z"}}),_c('path',{attrs:{"fill":"#71798A","fill-rule":"evenodd","d":"M9 15.887a6 6 0 110-12 6 6 0 010 12zm0-.75a5.25 5.25 0 100-10.5 5.25 5.25 0 000 10.5z","clip-rule":"evenodd"}})])
          )
        }
      }
    